module.exports = __webpack_public_path__ + "media/4x3/bh-ef135f3c.svg";